import FormTextbox from "../FormTextBox/FormTextbox"
// @ts-ignore
import LinkIcon from "./link.svg?react"
// @ts-ignore
import LineIcon from "./line.svg?react"
import {
  DependentWrapper,
  DependentWrapperOuter,
  LinkWrapper,
  MessageAndInputWrapper,
  ValidationMessage,
} from "./DependentFields.styles"
import { useAppSelector } from "../../app/hooks"
import { selectLGInternalUser } from "../../activeScreenSlice"

export interface Props {
  labels: string[]
  validationState: "default" | "error" | "ok"
  values: any[]
  onChanges: ((v: any) => any)[]
  validationMessage?: string
  disabled:boolean
}

export default function DependentFields(props: Props) {
  return (
    <MessageAndInputWrapper>
      <DependentWrapperOuter>
        <LinkWrapper validationState={props.validationState}>
          <LineIcon transform={"scale(1.5)"} />
          <LinkIcon transform={"scale(1.5)"} />
          <LineIcon transform={"rotate(180), scale(1.5)"} />
        </LinkWrapper>
        <DependentWrapper>
          {props.labels.map((label, idx) => (
            <FormTextbox
              key={idx}
              label={label}
              validationState={props.validationState}
              value={props.values[idx]}
              onChange={props.onChanges[idx]}
              disabled={props.disabled}
            />
          ))}
        </DependentWrapper>
      </DependentWrapperOuter>
      {props.validationState === "error" && (
        <ValidationMessage>
          {props.validationMessage
            ? props.validationMessage
            : "Values do not match"}
        </ValidationMessage>
      )}
    </MessageAndInputWrapper>
  )
}
